import { useState } from 'react';
import { observer } from 'mobx-react';
import { useStores } from 'hooks/useStores';
import { Step1 } from './steps/Step1';
import { Step2 } from './steps/Step2';
import { Step3 } from './steps/Step3';
import * as S from './styles';

export type StepType = {
  number: number,
  currentStep: number,
  nextStep?: (value: any) => void,
  prevStep?: Function
}

export const Feedback = observer(() => {

  const { businessStore } = useStores();

  const [{step, values}, setData] = useState<{step: number, values: Array<any>}>({step: 1, values: []})

  const nextStep = value => {
    let newValues = [...values];
    newValues[step - 1] = value;

    setData({step: step + 1, values: newValues})
  }
  const prevStep = () => setData({step: step - 1, values: values});
  const finalStep = value => {
    let newValues = [...values];
    newValues[step - 1] = value;

    setData({step: step, values: newValues});
    
    alert('Данные могли бы быть отправлены')
    console.log(values)

    businessStore.toggleFeedback();
  }

  return (
      <S.Backdrop>
        <Step1 number={1} currentStep={step} nextStep={nextStep}/>  
        <Step2 number={2} currentStep={step} nextStep={nextStep} prevStep={prevStep}/>
        <Step3 number={3} currentStep={step} nextStep={finalStep} prevStep={prevStep}/>
      </S.Backdrop>
  )
})